import * as React from 'react';
import { useMemo, useState } from 'react';
import { ProgressState } from '../../common/enum/progressState';
import { ColorDefines } from '../../interface/IColors';
import useActionExecutor from '../service/actionExecutor';
import "./ButtonElement.scss";
import { ButtonProps, ButtonDefines } from './IButton';
import { EventType } from '../../common/types/event';
import { ActionType } from '../../common/enum/action';

interface ButtonElementProps {
  props: ButtonProps;
  defines: ButtonDefines;
  colors: ColorDefines;
}

const ButtonElement = ({ props, defines, colors }: ButtonElementProps) => {
  const { click, executing } = useActionExecutor(props.event, defines);
  
  const label: string = useMemo(() => {
    if (typeof defines.label === "string")
      return defines.label as string;
    if (props.state === ProgressState.BEFORE)
      return defines.label?.before || defines.label.default || "";
    if (props.state === ProgressState.CURRENT)
      return defines.label?.current || defines.label.default || "";
    if (props.state === ProgressState.AFTER)
      return defines.label?.after || defines.label.default || "";
    return defines.label.default || "";
  }, [defines.label, props.state]);
  
  return (
    <div className="button">
      <button
        type={defines.buttonType || "button"}
        className={(defines.classList || []).join(" ")}
        name={defines.name}
        disabled={defines?.event?.click?.actions &&
          defines.event.click.actions.includes(ActionType.COLLAPSE) &&
          defines.event.click.actions.length === 1 ?
            false : (!props.enable || executing[EventType.click])
        }
        onClick={e => {
          if (executing[EventType.click]) return null;
          return click(e);
        }}
      >
        <span>{label}</span>
      </button>
    </div>
  )
}

export default ButtonElement;